interface StatCardProps {
  label: string;
  value: string;
  delta: string;
  trend: "up" | "down";
  icon: string;
  tone: "primary" | "accent" | "secondary";
}

const TONE: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function StatCard({ label, value, delta, trend, icon, tone }: StatCardProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200">
      <div className="flex items-start justify-between">
        <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${TONE[tone]}`}>
          <i className={`${icon} text-xl`} />
        </span>
        <span
          className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium ${
            trend === "up" ? "bg-accent-100 text-accent-800" : "bg-secondary-100 text-secondary-800"
          }`}
        >
          <i className={trend === "up" ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
          {delta}
        </span>
      </div>
      <p className="mt-4 font-heading text-2xl font-semibold text-foreground-950">{value}</p>
      <p className="mt-1 text-sm text-foreground-500">{label}</p>
    </div>
  );
}